import React, { Component } from 'react';
import { Container} from 'semantic-ui-react';
import { PtSelect } from '../../../grit-utilities';
import ScrollArea from 'react-scrollbar';
import DropdownLib from '../../../DropdownLib';

export default class Ownership extends Component {

    constructor(props) {
        super(props);
        const { ownModel } = this.props;
        this.state = ownModel.ownership;
    }

    render() {
        const { functionalClassOptions,
                maintenanceOptions,
                roadwayTypeOptions } = DropdownLib.getDropdowns().OL_Ownership;
        const { ownerOptions } = DropdownLib.getDropdowns().OL_Ownership;
        return (
            <Container>
                <ScrollArea
                    speed={1}
                    className={!window.mobileAndTabletcheck() ? "area_desktop" : "area_mobile"}
                    contentClassName="content"
                    smoothScrolling={true}>
                    <PtSelect label="Owner" options={ownerOptions} onChange={this.onChangeDropdown} disabled={this.props.disabled}
                        defaultVal={this.state.owner} name="owner" />
                    <PtSelect label="Functional Class" options={functionalClassOptions} onChange={this.onChangeDropdown} disabled={this.props.disabled}
                        defaultVal={this.state.functionalClass} name="functionalClass" />
                    <PtSelect label="Maintenance" options={maintenanceOptions} onChange={this.onChangeDropdown} disabled={this.props.disabled}
                        defaultVal={this.state.maintenance} name="maintenance" />
                    <PtSelect label="Roadway Type" options={roadwayTypeOptions} onChange={this.onChangeDropdown} disabled={this.props.disabled}
                        defaultVal={this.state.roadwayType} name="roadwayType" />
                </ScrollArea>
            </Container>
        );
    }

    onChangeDropdown = (e) => {
        const { target } = e;
        const {name, value} = target;
        this.props.triggerNeedSave();
        // eslint-disable-next-line
        this.setState({ [name]: parseInt(value) });
    }

    componentDidUpdate() {
        this.props.ownModel.ownership = this.state;
    }
}


// WEBPACK FOOTER //
// ./src/layers/tabs/owner-load-limits/ownership.js